<template>
  <div class="mt-5" v-observe-visibility="{
          callback: visibilityChanged,
          once: true,
          rootMargin: '-300px'
        }">
    <section class="bg-blue">
      <div class="container">
        <h2 id="partofgov">{{ $t('partofgov_question') }}</h2>

        <i18n tag="p" class="answer" path="partofgov_answer">
          <template v-slot:fraction_percentage>
            <span class="emph">{{ top.x | percentage(0) }}</span>
          </template>
          <template v-slot:fraction_title>
            <span class="emph">{{ top.title }}</span>
          </template>
        </i18n>

        <DotChart :data="plotData" @hover="hovered" />
      </div>
    </section>
    <section v-if="!dashboard">
      <div class="container">

        <i18n tag="p" path="partofgov_text">
          <template v-slot:coalition_probabilities>
            <a v-on:click="scrollTo('coalition')">{{ $t('other_coalition_probabilities')}}</a>
          </template>
          <template v-slot:sum_of_coalitions>
            <b>{{ $t('partofgov_sum_of_coalitions') }}</b>
          </template>
          <template v-slot:here>
            <router-link :to="'/' + $i18n.locale + '/faq#faq-4'">{{ $t('other_here')}}</router-link>.
          </template>
        </i18n>

      </div>
    </section>
  </div>
</template>

<script>
import DotChart from "./DotChart";
import { filter } from "lodash";

export default {
  name: "PartOfGov",
  components: {
    DotChart,
  },
  data() {
    return {
      index: 0,
    };
  },
  computed: {
    top() {
      let data = this.$store.getters.partOfGovernmentChartData;

      if (data && data.points && data.points.length > 0) {
        let point = data.points[this.index];

        return {
          x: point.x,
          title: this.$store.getters.partyInText[point.id],
        };
      }

      return { x: 0, title: "NA" };
    },
    plotData() {
      return this.$store.getters.partOfGovernmentChartData;
    },
    advantageCDU() {
      let forecast = this.$store.getters.forecastTableData;

      if (forecast.length == 0) return 0;

      let cdu = filter(forecast, { party_id: 1 })[0];
      let gruene = filter(forecast, { party_id: 4 })[0];

      return cdu.forecast - gruene.forecast;
    },
    probCDU() {
      if (this.plotData.points.length == 0) return 0;

      let cdu = filter(this.plotData.points, { id: 1 })[0];

      return cdu.x;
    },
  },
  methods: {
    hovered(index) {
      this.index = index;
    },
    probParty(id) {
      if (this.plotData.points.length == 0) return 0;

      let party = filter(this.plotData.points, { id: id })[0];

      return party.x;
    },
    percParty(id) {
      let forecast = this.$store.getters.forecastTableData;

      if (forecast.length == 0) return 0;

      let party = filter(forecast, { party_id: id })[0];

      return party.forecast;
    },
        visibilityChanged (isVisible) {
            if (isVisible) {
                this.$store.dispatch('getPartOfGovernment');
            }
        },
    scrollTo (id) {
      // scroll to correct position
      let navbar = document.getElementsByClassName("navbar-container")[0];
      let question = document.getElementById(id);
      let topOfElement = question.offsetTop - navbar.offsetHeight - 10;
      window.scroll({ top: topOfElement, behavior:'smooth' });
    }
  },
};
</script>

<style lang="scss" scoped>
</style>